var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 50 50", width: "50", height: "50" }, props),
    React.createElement("path", { fill: "none", stroke: "#d0cece", strokeWidth: "2", strokeMiterlimit: "10", d: "M1 6h48v38H1z" }),
    React.createElement("path", { fill: "none", stroke: "#d0cece", strokeWidth: "2", strokeMiterlimit: "10", d: "M1 30l10-10 4 6 5-1 4 4h6l7 5h12.014" }),
    React.createElement("circle", { cx: "37.5", cy: "17.5", r: "3.5", fill: "none", stroke: "#d0cece", strokeWidth: "2", strokeMiterlimit: "10" })
  );
});